import { Context, useContext } from 'react';

import { context as mjsFareEstimateContext } from './FareEstimateContextV1.mjs';

export interface FareEstimateContextV1Type {
  is_retry: boolean;
  set_is_retry: (isRetry: boolean) => void;
}

const context = mjsFareEstimateContext as Context<FareEstimateContextV1Type>;

export function useFareEstimateContext(): FareEstimateContextV1Type {
  return useContext(context);
}

export { context as FareEstimateContextV1Raw };
